module.exports = __webpack_public_path__ + "static/media/mountain-callling-02.6f77a7b9.jpg";